import { GameVars } from "../GameVars";


export class ScoreContainer extends Phaser.GameObjects.Container {

    private static readonly NUMBER_MS = 5;
    private score: Phaser.GameObjects.Image[];
    private spacing: number;
    private scoreNum: number;
    private scoreTotal: number;
    private tween: Phaser.Tweens.Tween;
    private textureAtlas: string;

    constructor(scene: Phaser.Scene, textureAtlas: string, spacing: number = 0) {

        super(scene);

        this.textureAtlas = textureAtlas;
        this.score = [];
        this.spacing = spacing;
        this.scoreNum = 0;
        this.scoreTotal = 0;
        this.tween = null;
    }

    public getScore(): number {

        return this.scoreTotal;
    }

    public updateScore(score: number) {

        if (this.tween) {
            this.tween.remove();
        }

        let diff = score - this.scoreTotal;
        this.scoreTotal = score;

        var that = this;
        this.tween = this.scene.tweens.add({
            targets: this,
            scoreNum: score,
            duration: diff * ScoreContainer.NUMBER_MS,
            ease: Phaser.Math.Easing.Linear,
            onUpdate: function() {
                that.changeScoreNumbers(GameVars.formatNumber(Math.floor(that.scoreNum)).toString());
            },
            onComplete: function() {
                that.tween = null;
            }
        });
    }   

    private changeScoreNumbers(score: string): void {

        this.destroyScore();

        const texture = this.scene.textures.get(this.textureAtlas);
        if (!texture) {
            return;
        }

        const widths: number[] = [];
        for (let i = 0; i < score.length; ++i) {
            const frame = texture.get(score[i]);
            widths.push(frame ? frame.width : 0);
        }

        const totalWidth = widths.reduce((acc, width, index) => {
            if (index === 0) {
                return width;
            }
            return acc + this.spacing + width;
        }, 0);

        let currentX = -totalWidth * .5;


        for (let i = 0; i < score.length; ++i) {
            
            const width = widths[i];
            const frameKey = score[i];
            const letter = new Phaser.GameObjects.Image(this.scene, currentX + width * .5, 0, this.textureAtlas, frameKey);
            letter.setOrigin(.5);

            this.score.push(letter);
            this.add(letter);

            currentX += width + this.spacing;
        }
    }

    private destroyScore(): void {

        if (this.score.length > 0) {
            for (let i = 0; i < this.score.length; ++i) {
                this.score[i].destroy();
            }
            this.score = [];
        }
    }
};